import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { SimpleQueryUser } from './../../../shared/dtos/simpleQueryUser';
import { ReferentielDTO } from './../../../shared/dtos/referentielDTO';
import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { GestionReferentielComponentService } from './../gestion-referentiel-component.service';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Ca1Service } from './../../../shared/services/societe-linked/ca1.service';
import { UserService } from './../../../shared/services/user.service';
import { SocieteService } from './../../../shared/services/simple/societe.service';
import { SessionService } from './../../../shared/services/session.service';
import { ToastrService } from 'ngx-toastr';
import { TrieTabService } from './../../../shared/services/utilities/trie-tab.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Ca1Model } from './../../../shared/models/societe-linked/ca1.model';
import { SocieteModel } from './../../../shared/models/simple-types/societe.model';
import { Component, OnInit, Output, EventEmitter, Injector, ViewChild } from '@angular/core';
import { ModalAddCa1Component } from 'src/app/shared/components/modals/modal-add-ca1/modal-add-ca1.component';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';

export interface DialogData {
  result: boolean;
}
@Component({
  selector: 'app-gestion-ca1',
  templateUrl: './gestion-ca1.component.html',
  styleUrls: ['./gestion-ca1.component.scss']
})
export class GestionCa1Component {
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: Ca1Model;
  displayedColumns: string[] = ['code', 'libelle', 'site', 'action'];
  dataSource: Ca1Model[];
  matDataSource = new MatTableDataSource<Ca1Model>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  ca1s: Ca1Model[] = [];
  droitLevel = 0;
  sites: SiteModel[] = [];
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router,
              public dialog: MatDialog,
              private comp: TrieTabService,
              injector: Injector,
              private route: ActivatedRoute,
              private toastr: ToastrService,
              private ca1Service: Ca1Service,
              private societeService: SocieteService,
              private toastrService: ToastrService,
              private siteService: SiteService,
              private gestionReferentielComponent: GestionReferentielComponentService) {
     this.route.params.subscribe((params: any) => {
       if (params.id === '0') {
         this.toastrService.error('Erreur durant la récupération du ca1.', 'Erreur');
         this.router.navigate(['/']);
       } else {
         this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
           if (societe) {
            this.siteService.getFromSociete(societe.id).subscribe(sites => {
              this.sites = sites;
            });
            this.societe = societe;
            this.objet.query = '';
            this.objet.pageNumber = 0;
            this.objet.pageSize = this.pageSize;
            this.objet.order = 'libelle';
            this.matDataSource.paginator = this.paginator;
            this.loadPage();
           }
         });
       }
     });

     this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
      };
     this.mySubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.router.navigated = false;
        }
      });
     }

  getSitebyCode(code): SiteModel{
    return this.sites.find(s => s.code === code);
  }


  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateCa1FormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddCa1Component, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          ca1s: this.ca1s,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(ca1: Ca1Model): void {
    const form = this.gestionReferentielComponent.getEditCa1FormGroup(ca1);
    const dialogRef = this.dialog.open(ModalAddCa1Component, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          ca1s: this.ca1s,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(ca1: Ca1Model): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du ca1',
        message: 'Êtes-vous sur de vouloir supprimer le ca1 ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const dialogSpinner = this.dialog.open(SpinnerModalComponent);
        this.ca1Service.delete(ca1.id).subscribe((response: Ca1Model) => {
          this.toastrService.success('Le ca1 a bien été supprimé');
          dialogSpinner.close();
          this.loadPage();
        }, (error) => dialogSpinner.close());
      }
    });
  }

  orderUsers(nas: Ca1Model[]): Ca1Model[] {
    nas = nas.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return nas;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.ca1Service.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<Ca1Model>) => {
      if (query.objets != null) {
        this.ca1s = query.objets;
      } else {
        this.ca1s = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<Ca1Model>(this.ca1s);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}



